import { render } from "./approuvedemande.vue?vue&type=template&id=39ad7cb2&scoped=true"
import script from "./approuvedemande.vue?vue&type=script&lang=js"
export * from "./approuvedemande.vue?vue&type=script&lang=js"

import "./approuvedemande.vue?vue&type=style&index=0&id=39ad7cb2&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad7cb2"]])

export default __exports__